import { render } from "./TestResults.vue?vue&type=template&id=ec08e4dc"
import script from "./TestResults.vue?vue&type=script&lang=js"
export * from "./TestResults.vue?vue&type=script&lang=js"

import "./TestResults.vue?vue&type=style&index=0&id=ec08e4dc&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__